import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';

export default class NumPad extends AContainer
{
    constructor(scene, x, y)
    {
        super(scene);

        this.x = x;
        this.y = y;
        this.endX = this.scene.mid.x + 300;
        this.endY = this.scene.mid.y;

        this.createNumPad();
        this.tweenInNumPad();

        this.scene.addToParent(this, this.scene);
    }

    createNumPad()
    {
        this.keys = [];
        this.bg = this.scene.addImage(0, 0, "Number_Entry_UI", this.scene.defaultAtlas, this);
        this.field = this.scene.addImage(-48, 170, "Number_Field", this.scene.defaultAtlas, this);

        this.inputField = this.scene.addText(this.field.x, this.field.y - 2, 40, "383334", gameData.fonts.numPad, "", this, true);

        for (let i=1; i<4; i++)
        {
            let key = this.scene.addButton(-95 + ((i-1)*95), -170, "Btn_" + i, {}, ()=>{this.inputNumbers(i);}, this);
            this.keys.push(key);
        }

        for (let k=4; k<7; k++)
        {
            let key = this.scene.addButton(-95 + ((k-4)*95), -85, "Btn_" + k, {}, ()=>{this.inputNumbers(k);}, this);
            this.keys.push(key);
        }

        for (let m=7; m<10; m++)
        {
            let key = this.scene.addButton(-95 + ((m-7)*95), 0, "Btn_" + m, {}, ()=>{this.inputNumbers(m);}, this);
            this.keys.push(key);
        }

        let key0 = this.scene.addButton(-95, 85, "Btn_0", {}, ()=>{this.inputNumbers(0);}, this);
        this.keys.push(key0);

        this.del = this.scene.addButton(48, 85, "Btn_Backspace", {}, ()=>{
            this.scene.playSound("click");
            this.inputField.text = this.inputField.text.substring(0, this.inputField.text.length - 1);
        }, this);
        this.keys.push(this.del);

        this.check = this.scene.addButton(96, 170, "Btn_Check", {}, ()=>{this.checkAnswer();}, this);
        this.keys.push(this.check);

        this.disableKeys();
    }

    inputNumbers(txt)
    {
        this.scene.playSound("click");
        if(this.inputField.text.length <= 5) this.inputField.text += txt;
    }

    disableKeys()
    {
        this.keys.forEach((key)=>{
            key.setEnabled(false);
            this.scene.addTween(key, 300, {alpha:.33}, Phaser.Math.Easing.None);
        });

        this.scene.addTween(this.field, 300, {alpha:.33}, Phaser.Math.Easing.None);
    }

    enableKeys()
    {
        this.keys.forEach((key)=>{
            key.setEnabled(true);
            this.scene.addTween(key, 300, {alpha:1}, Phaser.Math.Easing.None);
        });

        this.scene.addTween(this.field, 300, {alpha:1}, Phaser.Math.Easing.None);
    }

    checkAnswer()
    {
        this.scene.playSound("click");
        // console.log(gameData.graphingQuestions[gameData.level-1].answer.toString(), this.inputField.text);
        if(gameData.graphingQuestions[gameData.level-1].answer.toString() === this.inputField.text){
            // console.log("CORRECT ANSWER");
            this.scene.playSound("correct_pattern");
            this.disableKeys();

            this.scene.navBar.tweenOutInstructions();

            // console.log(gameData.level-1, this.scene.activeBugs[gameData.level-1]);
            let startInd = 0;
            this.scene.dragBugs.forEach((bug)=>{
                if(gameData.level-1 === 0){
                    bug.character.play("Cheer", false).state.timeScale = 1.5;
                    bug.startInd = startInd;
                    startInd++;
                } else {
                     this.scene.activeBugs[gameData.level-1].forEach((vial)=>{
                        if(bug.startColorName === vial.name) {
                            bug.character.play("Cheer", false).state.timeScale = 1.5;
                            bug.startInd = startInd;
                            startInd++;
                        }
                     });
                }
            });
        } else {
            // console.log("WRONG ANSWER");
            let randSound = "incorrect" + Phaser.Math.Between(1, 4);
            this.scene.playSound(randSound);
            this.disableKeys();

            this.scene.dragBugs.forEach((bug)=>{
                bug.character.play("Sad", false);
            });
        }

        this.inputField.text = "";
    }

    tweenInNumPad()
    {
        this.scene.addTween(this, 1000, {x:this.endX}, Phaser.Math.Easing.Quadratic.Out,
            ()=>{this.enableKeys();});
    }

    tweenOutNumPad()
    {
        this.disableKeys();

        this.scene.addTween(this, 1000, {x:this.scene.mid.x*2 + this.bg.width/2}, Phaser.Math.Easing.Quadratic.In);
    }

    cleanUp()
    {
        //console.log("cleaning UP");
       this.keys.forEach((key)=>{key.destroy();});

       this.keys = [];
       
       this.bg.destroy();
       this.field.destroy();
    }
}